import store from '@/store/store';
import { tryParseInt } from '@/utils/number';
import PlayerMedicalExamination from '@/views/team/tabs/player/MedicalExamination.vue';

export const teamPlayerMedicalExaminationRoute = {
  path: 'medicalExamination',
  name: 'teamPlayerMedicalExamination',
  component: PlayerMedicalExamination,
  meta: {
    title: 'titles.team.medicalExaminations',
    breadcrumb: {
      title: 'breadcrumbs.teams.medicalExamination'
    }
  },
  beforeEnter: (to: any, from: any, next: any) => {
    store.commit('team/player/setId', tryParseInt(to.params.playerId));
    if (!to.query.order) {
      next({ name: to.name, params: to.params, query: { order: 'end', desc: true } });
    } else {
      next();
    }
  }
};
